import { equalizeRowHeights } from '@/foundations/helpers/equalise-row-heights.ts';

export default (printElementId) => {
  const el = document.getElementById(printElementId);
  el.classList.remove('d-none');
  equalizeRowHeights(el, '.keyword-row');
  // Get HTML to print from element
  const prtHtml = document.getElementById(printElementId).innerHTML;
  // Get all stylesheets HTML
  let stylesHtml = '';

  for (const node of [...document.querySelectorAll('link, style')]) {
    stylesHtml += node.outerHTML;
  }
  stylesHtml += `
        <style type="text/css">
            html {
                background-color: #fff;
            }
            body {
                background-color: #fff;
                margin-top: 0!important;
            }
            .v-application {
                background-color: #fff !important;
            }
            #close-button {
                position: absolute;
                top: 10px;
                left: 10px;
                min-width: initial;
                height: 30px;
                padding: 0 2px;
            }
            @media print {
                #close-button {
                    display: none;
                }
            }
        </style>
    `;
  // Open the print window
  const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

  WinPrint.document.write(`
        <!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body class="v-application">
              <div id="close-button" class="p-5 cursor-pointer">
                <i class="mdi-close mdi v-icon notranslate v-theme--light v-icon--size-default" aria-hidden="true"></i>
              </div>
              ${prtHtml}
            </body>
          </html>`);
  WinPrint.document.close();
  WinPrint.focus();
  // Close button
  const closeBtn = WinPrint.document.getElementById('close-button');
  closeBtn.addEventListener('click', () => {
    WinPrint.close();
  });
  setTimeout(() => {
    WinPrint.print();
    WinPrint.close();
    el.classList.add('d-none');
  }, 1000);
};
